<!-- 基地 右侧展示的详情 -->
<style lang="stylus" scoped>
.details {
  position: absolute;
  right: 30px;
  top: 152px;
  width: 469px;
  color: #fff;

  .part-1, .part-2, .part-3 {
    margin-bottom: 13px;
    background: rgba(0, 36, 90, 1);
    border: 1px solid #4975E9;
  }

  .part-1 {
    font-size: 24px;
    font-weight: bold;

    .nav {
      display: flex;
      justify-content: space-between;
      height: 69px;
      padding: 20px 30px 0;
    }

    .content {
      height: 440px;
    }

    .content1 {
      overflow: hidden;
    }

    .content2 {
      padding: 20px;

      span {
        float: right;
        color: #00FFFF;
      }

      .see-details {
        width: 425px;
        height: 60px;
        margin-top: 50px;
        line-height: 60px;
        border: 1px solid rgba(255, 255, 255, 1);
        border-radius: 10px;
        text-align: center;
      }

      .modal-details {
        position: fixed;
        right: 600px;
        background: #ffffff;
        width: 845px;
        height: 515px;
        // border 3px solid #00A8FF
        z-index: 100;

        .close {
          position: absolute;
          right: -20px;
          top: -20px;
          width: 40px;
          height: 40px;
          background: url('~/static/img/base/close.png');
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
    }

    .content3, .content4 {
      padding: 0 15px;

      &>div {
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #4975E9;

        span:last-child {
          float: right;
        }
      }
    }

    .content4 {
      span:last-child {
        color: #00FFFF;
      }
    }
  }

  .part-2 {
    font-size: 24px;
    font-weight: bold;

    .title {
      height: 65px;
      padding-left: 20px;
      line-height: 65px;
      border-bottom: 1px solid #4975E9;
    }

    .content {
      display: flex;
      justify-content: space-between;
      height: 138px;
      padding: 40px 20px;
    }
  }

  .part-3 {
    height: 140px;
    padding: 40px 20px;
    font-size: 25px;
    font-weight: bold;

    p {
      margin-bottom: 15px;
    }
  }
}

.icon {
  width: 27px;
  height: 31px;
  background-image: url('../../../../static/img/base/nav.png');
  background-repeat: no-repeat;
  background-size: cover;
}

.icon-1 {
  background-position: 0 0;
}

.icon-2 {
  width: 34px;
  height: 28px;
  background-position: -105px 0;
}

.icon-3 {
  background-position: -250px 0;
}

.icon-4 {
  background-position: -375px 0;
}

.icon-active-1, .icon-active-2, .icon-active-3, .icon-active-4 {
  background-image: url('../../../../static/img/base/nav-active.png');
}

.swiper-div {
  text-align: center;
  color: #fff;
  .img-item {
    width: 470px;
    height: 300px;
  }
  .name{
    font-size: 30px;
    color: rgba(0,255,245,1);
    margin-bottom: 34px;
  }
  .monitor{
    font-size:20px;
    margin-top: 20px;
  }
}
.swiper-button-next, .swiper-button-prev
  width 20px
  height 23px
  top 100px
.swiper-button-prev
  background url("../../../../static/img/base/left.png")
  background-size 100% 100%
.swiper-button-next
  background url("../../../../static/img/base/right.png")
  background-size 100% 100%
</style>

<template>
  <div class="details">
    <div class="part-1">
      <div class="nav">
        <div
          v-for="(item, index) in navItem"
          :key="index"
          :class="['icon', 'icon-' + item, {['icon-active-' + item]: activeItem == index}]"
          @click="switchNav(index)"
        ></div>
      </div>
      <div class="content content1" v-if="activeItem === 0">
        <!-- <img src="static/img/base/part1-content1.png" alt="" width="100%"> -->
        <swiper :options="swiperOption" class="swiper-wrap" ref="mySwiper" v-if="banner.length!=0">
          <swiper-slide v-for="(item,index) in banner" :key="index">
            <div class="swiper-div">
              <p class="name">{{item.name}}</p>
              <img class="img-item" :src="item.src" alt>
              <p class="monitor">视频监控 {{index+1}}/{{banner.length}}</p>
            </div>
          </swiper-slide>
          <!-- 常见的小圆点 -->
          <!-- <div class="swiper-pagination"  v-for="(item,index) in banner" :key="index" slot="pagination" ></div> -->
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <div class="content content2" v-if="activeItem === 1">
        <div>
          气象站
          <span>运行中</span>
        </div>
        <div class="see-details" @click="showDetails">查看详情</div>
        <div class="modal-details" v-show="show">
          <i class="close" @click="hideDetails"></i>
          <img src="static/img/base/weather-station.png" alt>
        </div>
      </div>
      <div class="content content3" v-if="activeItem === 2">
        <div v-for="(item, index) in content3Data" :key="index">
          <span>{{item.name}}</span>
          <span>{{item.value}}</span>
        </div>
      </div>
      <div class="content content4" v-if="activeItem === 3">
        <div v-for="(item, index) in content4Data" :key="index">
          <span>{{item.name}}</span>
          <span>{{item.value}}</span>
        </div>
      </div>
    </div>
    <div class="part-2">
      <div class="title">显示内容</div>
      <div class="content">
        <div>
          <div style="margin-bottom: 15px">摄像头（1个）</div>
          <div>传感设备（1个）</div>
        </div>
        <div>
          <div style="margin-bottom: 15px">气象站（1个）</div>
          <div>灌溉设备（1个）</div>
        </div>
      </div>
    </div>
    <div class="part-3">
      <p>地址：广西省百色市</p>
      <p>占地面积：20000余亩</p>
    </div>
  </div>
</template>

<script>
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import part1Content1 from '../../../../static/img/base/part1-content1.png'
export default {
  props: {
    activeItem: {
      type: Number,
      default: 0
    }
  },
  data() {
    const that = this;
    return {
      navItem: [1, 2, 3, 4],
      banner: [{ name: '芒果园', src: part1Content1 }, { name: '百色芒果', src: part1Content1 }],
      swiperOption: {
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        // 自动播放
        autoplay: false,
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "horizontal",
        // 小手掌抓取滑动
        grabCursor: true,
        on: {
          // 滑动之后回调函数
          slideChangeTransitionStart: function () {
            /* realIndex为滚动到当前的slide索引值 */
            that.imgIndex = this.realIndex - 1;
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      activeIndex: 0,
      content3Data: [
        { name: '土壤温度', value: '24℃' },
        { name: '土壤湿度', value: '43%' },
        { name: '土壤铵根离子', value: '1.0ppm' },
        { name: '土壤硝酸离子', value: '0ppm' },
        { name: '土壤钾离子', value: ' 41.93ppm' }
      ],
      content4Data: [
        { name: '电磁阀1', value: '开' },
        { name: '电磁阀2', value: '开' },
        { name: '电磁阀3', value: '开' }
      ],
      show: false
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  mounted() {

  },
  methods: {
    switchNav(index) {
      this.$emit('indexChange', index)
    },
    showDetails() {
      this.show = true;
    },
    hideDetails() {
      this.show = false;
    }
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?16f0b5d0